import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SalesInspectionCompletedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SALES_INSPECTION_COMPLETED),
  roofPhotoFileIds: z.array(z.string()).min(1),
});
